<evsb-standard-modal-window [fullHeight]="true">
  <header>
    <evsb-modal-header
      [backLabel]="'modules.evsb.navigation.back' | translate"
      [backEnabled]="canGoBack"
      (back)="goBack()"
    >
      {{ 'modules.evsb.chargingCard.title' | translate }}
    </evsb-modal-header>
  </header>

  <div class="py-10 px-8 md:px-16 overflow-y-auto">
    <h3 class="text-grey text-sm">{{ 'modules.evsb.chargingCard.input.title' | translate }}</h3>
    <h2 class="text-xl text-grey-dark font-bold">{{ 'modules.evsb.chargingCard.input.subtitle' | translate }}</h2>

    <div class="flex w-full mb-24">
      <div class="flex-grow">
        <app-number-input
          class="block mt-12 mb-10"
          [value]="value"
          [min]="minCards"
          [max]="maxCards + 1"
          (valueChange)="valueChange($event)"
        >
        </app-number-input>
      </div>
      <div style="width: 40%">
        <img src="./assets/evsb/img/charging-card/credit-card.png" />
      </div>
    </div>

    <ul class="list-checkmark">
      <li *ngFor="let item of model.items" class="mb-3">{{ item | translate }}</li>
    </ul>
  </div>

  <footer class="flow-footer" [@fadeInUp]>
    <evsb-modal-footer>
      <div class="w-full flex flex-col gap-5 -mt-4">
        <div class="flex flex-row justify-between items-center">
          <p class="text-grey-dark text-xs">
            {{ 'modules.evsb.chargingCard.input.yourCombination' | translate }}
          </p>
          <evsb-currency-lg
            [end]="'modules.evsb.chargingCard.input.exclTax' | translate"
            [amount]="(unitPrice$ | async) * value"
          ></evsb-currency-lg>
        </div>
        <evsb-primary-button [fullWidth]="true" [state]="submitBtnState" (click)="add()">
          {{ 'modules.evsb.chargingCard.input.addToSolutions' | translate }}
        </evsb-primary-button>
      </div>
    </evsb-modal-footer>
  </footer>
</evsb-standard-modal-window>
